module.exports = __webpack_public_path__ + "images/2b760ac1e1d61f61504df49d5a260485.png";


//////////////////
// WEBPACK FOOTER
// ../public/images/google-play-icon.png
// module id = 661
// module chunks = 0